import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface WidgetBoxProps {
  $tone?: 'secondary' | 'accentTertiary';
  $size?: 'large';
}

export const WidgetBox = styled.div.withConfig({ componentId: 'sc-19ucmtf-0' })<WidgetBoxProps>`
    background: var(--_bg, var(--c-accent-alt-bg));
    color: var(--c-text-main);
    padding: var(--_padding);
    border-radius: var(--_radius, ${size(2)});

    ${({ $tone }) =>
      $tone === 'secondary'
        ? css`
                  --_bg: var(--c-secondary-bg);
              `
        : $tone === 'accentTertiary'
          ? css`
                  --_bg: var(--c-accent-tertiary-bg);
              `
          : undefined}

    ${({ $size }) =>
      $size === 'large'
        ? css`
                  --_padding: ${size(4)} ${size(3)};

                  ${(props) => props.theme.breakpoint.Md} {
                      --_padding: ${size(6)};
                  }
              `
        : css`
                  --_padding: ${size(3)} ${size(2)};

                  ${(props) => props.theme.breakpoint.Md} {
                      --_padding: ${size(4)} ${size(3)};
                  }
              `}
`;
